<div class="wrapper mb-5">
    <div class="row title-container align-items-center" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3"> Minhas recargas</span>
    </div>
    <div class="form-card mt-5">
        <div class="row container-fluid text-center type-tabs">
            <div class="col-md-6 col-sm-12 clickable purchaseTab"
                [class.purchaseTabSelect]="showStatusMinhasComprasList ===
                StatusMinhasComprasList.ComprasEmAndamento" (click)="showStatusMinhasComprasList=
                StatusMinhasComprasList.ComprasEmAndamento">
                Recargas em andamento
            </div>
            <!--<div class="col-4 clickable purchaseTab"
                [class.purchaseTabSelect]="showStatusMinhasComprasList ===
                StatusMinhasComprasList.ComprasSalvas" (click)="showStatusMinhasComprasList=
                StatusMinhasComprasList.ComprasSalvas">
                Recargas salvas
            </div>-->
            <div class="col-md-6 col-sm-12 clickable purchaseTab"
                [class.purchaseTabSelect]="showStatusMinhasComprasList ===
                StatusMinhasComprasList.ComprasAnteriores" (click)="showStatusMinhasComprasList=
                StatusMinhasComprasList.ComprasAnteriores">
                Recargas anteriores
            </div>
            <div class="col-md-6 col-sm-12 clickable purchaseTab"
                [class.purchaseTabSelect]="showStatusMinhasComprasList ===
                StatusMinhasComprasList.ComprasEmRascunho" (click)="showStatusMinhasComprasList=
                StatusMinhasComprasList.ComprasEmRascunho">
                Recargas em rascunho
            </div>
        </div>
        <!-- <div class="col-lg-4 col-md-4 col-sm-12"><input
            class="list-header-search-input w-100" type="search"
            placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" /></div> -->
        <app-compras-anteriores *ngIf="showStatusMinhasComprasList ===
            StatusMinhasComprasList.ComprasAnteriores"
            [filtroPesquisa]="filtroPesquisa"></app-compras-anteriores>
        <!--<app-compras-salvas *ngIf="showStatusMinhasComprasList ===
            StatusMinhasComprasList.ComprasSalvas" [filtroPesquisa]="filtroPesquisa"></app-compras-salvas>-->
        <app-compras-em-andamento *ngIf="showStatusMinhasComprasList ===
            StatusMinhasComprasList.ComprasEmAndamento"
            [filtroPesquisa]="filtroPesquisa"></app-compras-em-andamento>
        <app-compras-rascunho *ngIf="showStatusMinhasComprasList ===
            StatusMinhasComprasList.ComprasEmRascunho"
            [filtroPesquisa]="filtroPesquisa"></app-compras-rascunho>

    </div>

    <!-- <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-12 text-left"><span
                class="list-header-title">Meus pedidos</span></div>

        <div class="col-lg-4 col-md-4 col-sm-12"><input
                class="list-header-search-input w-100" type="search"
                placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" /></div>
    </div> -->
</div>

<!-- <div class="container-fluid"> -->
    <!--opções listagem-->


<!-- </div> -->
